import { render, staticRenderFns } from "./BusInspectionTaskModal.vue?vue&type=template&id=71c36de5&"
import script from "./BusInspectionTaskModal.vue?vue&type=script&lang=js&"
export * from "./BusInspectionTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports